import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { ButtonSkeleton, InputSkeleton, TextSkeleton } from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemMobile: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const middleInfos1 = [
    { label: 'Quantidade disponível', value: <TextSkeleton w="75%" /> },
    { label: 'IR', value: <TextSkeleton w="75%" /> },
  ];

  const middleInfos2 = [
    { label: 'Valor líquido', value: <TextSkeleton w="75%" /> },
    { label: 'Disponível em conta', value: <TextSkeleton w="75%" /> },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <TextSkeleton w="35%" />
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos1.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="50%">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos2.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="50%">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack space={Spacing['inline.xxxs']} justifyContent="space-between" w="full">
          <VStack space={Spacing['stack.quarck']} flexGrow={1}>
            <UI.Text color="neutral.black" variant="semibold">
              Unidades para resgate
            </UI.Text>
            <InputSkeleton />
          </VStack>
          <Stack alignSelf="flex-end" w="20%">
            <ButtonSkeleton borderRadius={BoxBorder.thick} />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
